import React from "react";
import categorywisebgimage from "../../assets/Images/Categorypagebgimage.webp";

const Topbg = () => {
  return (
    <div>
      <div
        className="h-80 w-full bg-cover bg-center"
        style={{ backgroundImage: `url(${categorywisebgimage})` }}
      >
        <div className="absolute top-80 left-24 transform -translate-y-1/2">
          <h1 className="text-4xl font-bold text-white">Home &rarr; Career</h1>
        </div>
      </div>
    </div>
  );
};

export default Topbg;
